module.exports = __webpack_public_path__ + "static/media/black.29494517.PNG";